export const BRAND = {
  name: "Rêv'dô",
  tagline: "L'excellence de la piscine à La Réunion",
  subtitle: "Entretien sur mesure • Dépannage rapide • Eau cristalline garantie",
  strong: "Chaque piscine mérite une attention d'exception.",
  phone: "+262 692 61 66 57",
  phoneHref: "tel:+262692616657",
  whatsappHref: "https://wa.me/262692616657",
  email: "revedo@orange.fr",
  emailHref: "mailto:revedo@orange.fr",
  logo:
    "https://customer-assets.emergentagent.com/job_72db6157-de11-4cad-b516-83fb9e963f41/artifacts/yq5f4p36_IMG_4645.jpeg",
  heroImage:
    "https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=2200&q=80",
  beforeAfter:
    "https://customer-assets.emergentagent.com/job_72db6157-de11-4cad-b516-83fb9e963f41/artifacts/ihbmm94v_IMG_4646.jpeg",
  beforeAfterAlt:
    "https://customer-assets.emergentagent.com/job_72db6157-de11-4cad-b516-83fb9e963f41/artifacts/10cuek15_IMG_4647.jpeg",
  techRoom:
    "https://customer-assets.emergentagent.com/job_72db6157-de11-4cad-b516-83fb9e963f41/artifacts/su96icm8_IMG_4648.jpeg",
  luxuryPool:
    "https://images.unsplash.com/photo-1519315901367-f34ff9154487?auto=format&fit=crop&w=1800&q=80",
};

export const BRAND_PHRASES = [
  "L'exigence au service de votre piscine",
  "Une eau parfaite, sans compromis",
  "Chaque piscine mérite l'excellence",
  "Intervention rapide et soignée",
];

export const SERVICES = [
  {
    id: "entretien-sur-mesure",
    icon: "Repeat",
    title: "Entretien sur mesure",
    lines: ["Passage quotidien", "Entretien hebdomadaire", "Toutes les deux semaines"],
    tag: "Service flexible et personnalisé",
  },
  {
    id: "depannage-piscine",
    icon: "Wrench",
    title: "Dépannage piscine",
    lines: ["Eau verte ou trouble", "Problème de filtration", "Panne générale", "Dysfonctionnement système"],
    tag: "Intervention rapide et efficace",
  },
  {
    id: "depannage-electrique",
    icon: "Zap",
    title: "Dépannage électrique piscine",
    lines: ["Pompe en panne", "Coffret électrique défectueux", "Disjoncteur qui saute"],
    tag: "Diagnostic précis et sécurisé",
  },
  {
    id: "depannage-pompe",
    icon: "Settings",
    title: "Dépannage pompe piscine",
    lines: ["Pompe bloquée ou HS", "Perte de pression", "Bruit anormal"],
    tag: "Réparation ou remplacement rapide",
    isNew: true,
  },
  {
    id: "installation-local",
    icon: "Building2",
    title: "Installation local technique",
    lines: ["Installation complète piscine", "Optimisation filtration", "Matériel professionnel"],
    tag: "Performance et durabilité",
  },
  {
    id: "installation-electrique",
    icon: "PlugZap",
    title: "Installation électrique piscine",
    lines: ["Coffret électrique", "Raccordements sécurisés", "Mise aux normes"],
    tag: "Sécurité et fiabilité",
    isNew: true,
  },
  {
    id: "traitement-eau",
    icon: "FlaskConical",
    title: "Traitement de l'eau",
    lines: ["Analyse complète", "Rééquilibrage pH / chlore", "Traitement choc eau verte"],
    tag: "Eau pure et cristalline",
  },
  {
    id: "entretien-mensuel",
    icon: "CalendarDays",
    title: "Entretien mensuel",
    lines: ["Nettoyage complet", "Contrôle système", "Traitement régulier"],
    tag: "Piscine toujours impeccable",
  },
  {
    id: "entretien-vacances",
    icon: "Plane",
    title: "Entretien pendant vos vacances",
    lines: ["Surveillance complète", "Entretien régulier", "Gestion de l'eau"],
    tag: "Tranquillité totale",
  },
  {
    id: "changement-sable",
    icon: "Hourglass",
    title: "Changement de sable filtre",
    lines: ["Remplacement sable", "Optimisation filtration", "Amélioration qualité eau"],
    tag: "Filtration performante",
    isNew: true,
  },
  {
    id: "changement-horloge",
    icon: "Timer",
    title: "Changement horloge piscine",
    lines: ["Réglage programmation", "Remplacement horloge HS", "Optimisation cycles filtration"],
    tag: "Meilleur contrôle de votre piscine",
    isNew: true,
  },
];

export const WHY_US = [
  { icon: "Rocket", title: "Intervention rapide et fiable", desc: "Présents sur site dans les meilleurs délais, sur toute l'île." },
  { icon: "Sparkles", title: "Service sur mesure", desc: "Chaque piscine a ses particularités — nous adaptons notre intervention." },
  { icon: "Award", title: "Expertise professionnelle", desc: "Un savoir-faire précis, pour des résultats à la hauteur de votre exigence." },
  { icon: "Droplets", title: "Résultats visibles immédiatement", desc: "Une eau saine, cristalline, et un système parfaitement fonctionnel." },
  { icon: "FileCheck", title: "Devis gratuit et transparent", desc: "Un diagnostic clair, un prix juste, sans mauvaise surprise." },
];

export const ZONES = ["Sud", "Nord", "Ouest"];

export const PROBLEM_TYPES = [
  "Eau verte / trouble",
  "Panne de pompe",
  "Problème de filtration",
  "Problème électrique",
  "Entretien régulier",
  "Installation / rénovation",
  "Traitement de l'eau",
  "Changement sable filtre",
  "Changement horloge",
  "Autre",
];
